
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			scrollHeight: 0
		};
	},
	props: {
		label: [String, Object],
		value: String,
		placeholder: String,
		disabled: Boolean,
		fancy: {
			type: Boolean,
		},
		tabindex: [Number, Number],
		resize: {
			type: Boolean,
		},
		autosize: {
			type: Boolean,
			default: true
		},
		minHeight: {
			type: Number,
			default: 60
		},
		maxHeight: {
			type: [Number],
			default: 150
		},
		autofocus: {
			type: Boolean
		},
		required: {
			type: Boolean
		},
		icon: String,
		iconLeft: String,
		iconClickHandler: Function,
	},
	computed: {
		_iconClickHandler():Function | undefined{
			return this.$listeners["icon-click"] as Function || this.iconClickHandler || undefined;
		},
		height():string{
			let contentHeight = this.scrollHeight;
			if (this.minHeight && contentHeight < this.minHeight){
				return `${this.minHeight}px`;
			}
			if (this.maxHeight && contentHeight > this.maxHeight) {
				return `${this.maxHeight}px`;
			}
			return `${contentHeight}px`;
		},
		disableOverflow():boolean {
			return !(this.maxHeight && this.scrollHeight > this.maxHeight);
		}
	},
	methods: {
		onInput(value:string){
			this.$emit("input", value);
		},
		onFocus(){
			this.$emit("focus");
		},
		onBlur(){
			this.$emit("blur");
		},
		iconClick(){
			if (this._iconClickHandler){
				this._iconClickHandler();
			}
		},
	},
});
